// import { addDoc, collection } from "firebase/firestore";
import { useState } from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet";
import { CgSpinner } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Header from "../../components/navbar/Header";
// import { toast } from "react-toastify";
// import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import InsuranceBanner from "../../assets/mobile-banners/Gem_Web_Banners_Insurance.webp";
import CustomSlider from "../../components/CustomSlider";
import { db } from "../../firebase";

const servicemobileSlides = [
  {
    img: InsuranceBanner,
    alt: "service",
  },
];
function Insurance() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const pattern = /^[6-9][0-9]{9}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Special handling for phone (numbers only)
    const newValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone) {
      toast.error("Please fill all required fields");
      return;
    }

    if (!pattern.test(form.phone)) {
      toast.error("Invalid phone number");
      return;
    }

    if (!agreed) {
      toast.error("Please accept the disclaimer");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "enquiries"), {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone,
        formType: "insurance",
        timestamp: serverTimestamp(),
      });

      toast.success("Form submitted successfully");

      setForm({ name: "", email: "", phone: "" });
      setAgreed(false);

      navigate("/thank-you");
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Maruti Suzuki Insurance Renewal in Hyderabad | Gem Motors</title>
        <meta
          name="title"
          content="Maruti Suzuki Insurance Renewal in Hyderabad | Gem Motors"
        />
        <meta
          name="description"
          content="Maruti Suzuki , Nexa car insurance renewal in Hyderabad & Secunderabad. Get cashless accident repairs, fair & transparent claim settlement. Looking to Renew Insurance Online for, Maruti Swift,Maruti Wagon R, Maruti Ertiga, Eeco, Maruti S-Presso, Maruti Alto 800,Maruti Vitara Brezza,Maruti Dzire, Celerio"
        />
      </Helmet>
      <Header />
      <div className="hidden md:block">
        <img
          src={require("../../assets/Banners_Insurance.jpg")}
          loading="lazy"
          className="w-full lg:h-[550px] object-cover"
          alt="inusrance banner"
        />
      </div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Insurance
        </p>
      </div>
      <div className="container px-5 py-16 mx-auto">
        <p className="text-2xl font-semibold text-red-500">Maruti Insurance</p>
        <form onSubmit={handleSubmit} className="mt-5 space-y-3">
          <div className="grid gap-3 lg:grid-cols-4 sm:grid-cols-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-blue-500 focus:border-blue-500"
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-blue-500 focus:border-blue-500"
                type="text"
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-blue-500 focus:border-blue-500"
                type="text"
                maxLength="10"
                minLength="10"
                name="phone"
                required
                value={form.phone}
                onChange={handleChange}
              />
              {!pattern.test(form.phone) && form.phone.length === 10 && (
                <small className="text-red-500">Invalid phone number</small>
              )}
            </div>
          </div>
          <p className="text-gray-700">
            <span className="font-bold text-black">Disclaimer</span>: I agree
            that by clicking the ‘Submit’ button below, I am explicitly
            soliciting a call / Message from Gem Motor Pvt. Ltd or its
            Representatives on my ‘Mobile’
          </p>
          <div className="flex items-start">
            <input
              id="disclaimer"
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <div className="ml-2 text-sm">
              <label htmlFor="disclaimer" className="font-medium text-gray-700">
                Please Agree with Following Disclaimer
              </label>
            </div>
          </div>
          <button
            className="hover:bg-[#1D3A8A] bg-red-500 duration-500 text-white rounded py-2.5 px-5"
            type="submit"
            disabled={loading || !pattern.test(form.phone) || !agreed}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <CgSpinner className="w-5 h-5 mr-2 text-white animate-spin" />
                Loading
              </div>
            ) : (
              "Get Your Insurance Now"
            )}
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
}

export default Insurance;
